import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const CollectionMember = ({ isDependentFilter }) => {
	const [options, setOptions] = useState([]);
	const [allOptionList, setAllOptionList] = useState([]);
	const storeData = []; //TODO ( fetch store data for corresponding field)
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		if (!isDependentFilter) {
			setOptions(allOptionList);
		}
	}, [storeData]);

	useEffect(() => {
		if (allOptionList?.length === 0 && !isDependentFilter) {
			//TODO ( dispatch store data for corresponding field)
		} else {
			onSetFieldData();
		}
	}, [dependentFilterList]);

	const onSetFieldData = () => {
		let responseData = isDependentFilter
			? dependentFilterList?.memberList
			: storeData?.map((item) => {
					return { id: item.id, name: item.name };
				});
		setAllOptionList(responseData);
		setOptions(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allOptionList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: allOptionList;
		setOptions(searchResult);
	};

	return (
		<>
			<FilterName type="COLLECTION_MEMBER" />
			<Checkbox type="COLLECTION_MEMBER" data={options} handleSearch={handleSearch} />
		</>
	);
};

export default CollectionMember;
